<template>
  <div class="hello">
    <div class="title">{{data.title}}</div>
    <div class="content" v-html="data.content"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: []
      }
    },
    created() {
      this.$http.schoolNewsDetail({
        id: this.$route.query.id
      }).then(res => {
        this.data = res.data
      })
    }
  }
</script>

<style scoped>
  .title {
    font-size: 24px;
    margin-bottom: 50px;
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/school/Guide.vue